// import React from 'react';
// import ReactDOM from 'react-dom';
// import './index.css';
// import App from './App';
// import * as serviceWorker from './serviceWorker';

// ReactDOM.render(<App />, document.getElementById('root'));

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import config from './config/domain';
import { initMixpanelService } from './components/Services/mixpanelService';

const container = document.getElementById('root');

if (!container) {
  throw new Error("Root container missing in index.html");
}

initMixpanelService(config.mixpanelToken);

const root = createRoot(container);
root.render(<App />);
